var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-avatar",class:_vm.computedClasses,on:{"click":_vm.onClick}},[_c('vue-avatar',{attrs:{"name":_vm.name,"url":_vm.url,"rounded":"","block":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }